export const censoredWords: string[] = [
  // Ukrainian
  'блять', 'хуй', 'пізда', 'єбать', 'сука', 'підар', 'говно', 'заєбісь',
  'нахуй', 'похуй', 'хуйня', 'піздець', 'єпта', 'бляха', 'хуйло', 'піздюк',
  'говнюк', 'заєба', 'нахуя', 'похуя', 'хуйово', 'піздюля', 'єпт', 'бля',
  'хуя', 'пізди', 'говна', 'заєб', 'наху', 'поху', 'хуй', 'пізд', 'єп', 'лох',
  'бидло', 'дурак', 'дурень', 'тупий', 'тупа', 'кретин', 'ідіот', 'мудило', 'манда',
  'сволота', 'сучий син', 'сучка', 'підарок', 'підареса', 'гнида', 'гондон', 'єбанат',
  // Russian
  'блять', 'хуй', 'пизда', 'ебать', 'сука', 'пидар', 'говно', 'заебись',
  'нахуй', 'похуй', 'хуйня', 'пиздец', 'епта', 'бляха', 'хуйло', 'пиздюк',
  'говнюк', 'заеба', 'нахуя', 'похуя', 'хуёво', 'пиздюля', 'епт', 'бля',
  'хуя', 'пизди', 'говна', 'заеб', 'наху', 'поху', 'хуй', 'пизд', 'еп', 'лошара',
  // English
  'fuck', 'shit', 'bitch', 'ass', 'dick', 'cock', 'pussy', 'cunt',
  'motherfucker', 'fucker', 'bastard', 'damn', 'hell', 'god', 'jesus',
  'fucking', 'shitty', 'asshole', 'dickhead', 'cockhead', 'pussycat',
  'cuntface', 'motherfucking', 'fucking', 'shit', 'ass', 'dick', 'cock',
  // Spanish
  'joder', 'mierda', 'puta', 'cabrón', 'polla', 'coño', 'gilipollas', 'hijo de puta',
  'puto', 'cabrona', 'polla', 'coño', 'gilipollas', 'hijo de puta', 'puto',
  'cabrón', 'polla', 'coño', 'gilipollas', 'hijo de puta', 'puto', 'cabrona',
  'polla', 'coño', 'gilipollas', 'hijo de puta', 'puto', 'cabrón', 'polla'
] as const;


export const TEXT_LENGTH_LIMIT = {
  GAME_TITLE: {
    MAX: 64,
    MIN: 6
  },
  GAME_DESCRIPTION: {
    MAX: 256,
    MIN: 0
  },
  SLUG: {
    MAX: 64,
    MIN: 6
  },
  GROUP_TITLE: {
    MAX: 32,
    MIN: 1
  },
  ROUND_TITLE: {
    MAX: 32,
    MIN: 1
  },
  CARD_TEXT: {
    MAX: 64,
    MIN: 0
  },
  EXPLANATION: {
    MAX: 320,
    MIN: 0
  },
  MAIN_QUESTION: {
    MAX: 320,
    MIN: 0
  },
  CORRECT_ANSWER: {
    MAX: 32,
    MIN: 1
  },
  MEDIA_NAME: {
    MAX: 64,
    MIN: 1
  },
  QUIZAI_TOPIC: {
    MAX: 128,
    MIN: 2
  },
  QUIZAI_DESCRIPTION: {
    MAX: 128,
    MIN: 2
  }
  // ...
} as const;

export type TextFieldKey = keyof typeof TEXT_LENGTH_LIMIT;
